export default __webpack_public_path__ + "static/media/jwt.d33657fb.svg";